<template>
    <div>
        <div id="user-feedback-menu" class="user-feedback-menu">
            <hox-loading-layer v-if="isLoggingOut" is-full-screen />
            <Poptip v-model="isPoptipActive" placement="left" class="user-menu__avatar-poptip">
                <hox-main-nav-button
                    has-circle-border
                    :show-tooltip="false"
                    data-testid="top-bar__user-feedback-menu-button"
                >
                    <Icon type="md-help" />
                    <template #tooltipContent>User feedback menu</template>
                </hox-main-nav-button>
                <template #content>
                    <a
                        href="https://jira.uhub.biz/servicedesk/customer/portal/4408/create/23837"
                        target="_blank"
                        rel="noreferrer"
                        class="user-menu__actions"
                        data-testid="top-bar__report-bug-button"
                    >
                        <Icon type="md-bug" />
                        <span>Report a bug</span>
                    </a>
                    <div class="user-menu__actions" data-testid="top-bar__knwoledge-button">
                        <Icon type="md-book" />
                        <div class="user-menu-option--knowledge">
                            Knowledge hub
                            <span>coming soon</span>
                        </div>
                    </div>
                </template>
            </Poptip>
        </div>
    </div>
</template>

<script lang="ts">
export default {
    name: "UserFeedbackMenu",
    data() {
        return {
            isLoggingOut: false,
            isPoptipActive: false
        };
    }
};
</script>

<style lang="scss">
@use "@style/variables" as *;

.user-feedback-menu {
    .user-menu__actions {
        display: flex;

        &:visited {
            color: var(--color-text-primary);
        }
    }

    .user-menu-option {
        display: flex;
        &--knowledge {
            display: flex;
            flex-direction: column;
            span {
                font-size: 9px;
                margin-top: -3px;
            }
        }
    }
}
</style>
